export const ERROR_NAME = 'UNAUTHORIZED_ERROR'

export class UnauthorizedError extends Error {
  constructor(message) {
    super(message || 'Authorization error')
    this.name = ERROR_NAME
  }
}

export default UnauthorizedError
